export const PERMIT_ALREADY_RENEWED = 'Permit is already renewed';
export const SCHEDULING_ALREADY_BOOKED = 'Selected slot is already booked. Please choose another slot.';
